import { B300, N70 } from '@atlaskit/theme/colors';
export var getMarkerColor = function getMarkerColor(status) {
  switch (status) {
    case 'unvisited':
      return "var(--ds-icon-subtle, ".concat(N70, ")");
    case 'current':
    case 'visited':
    case 'disabled':
      return "var(--ds-icon-brand, ".concat(B300, ")");
    default:
      return;
  }
};
export var getTextColor = function getTextColor(status) {
  switch (status) {
    case 'unvisited':
      return "var(--ds-text-subtlest, #626F86)";
    case 'current':
      return "var(--ds-text-brand, #0C66E4)";
    case 'visited':
      return "var(--ds-text, #172B4D)";
    case 'disabled':
      return "var(--ds-text-disabled, #091E424F)";
    default:
      return;
  }
};
export var getFontWeight = function getFontWeight(status) {
  switch (status) {
    case 'unvisited':
      return "var(--ds-font-weight-regular, 400)";
    case 'current':
    case 'visited':
    case 'disabled':
      return "var(--ds-font-weight-bold, 700)";
    default:
      return undefined;
  }
};